import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, ElementRef, Inject, PLATFORM_ID, ViewChild } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { LojasComponent } from "../components/lojas/lojas.component";
import { TitleComponent } from "../components/title/title.component";
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-sobre',
  standalone: true,
  imports: [
    CommonModule,
    LojasComponent,
    TitleComponent
  ],
  templateUrl: './sobre.component.html',
  styleUrl: './sobre.component.scss'
})
export class SobreComponent {
  @ViewChild('contadoresSection') contadoresSection!: ElementRef;
  private observer!: IntersectionObserver;
  private animacaoIniciada = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router,
    private titleService: Title
  ) { }

  ngAfterViewInit() {
    this.titleService.setTitle('Sobre Nós - Cancian Imóveis')

    this.observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting && !this.animacaoIniciada) {
          this.animacaoIniciada = true;
          this.iniciarContadores();
          this.observer.disconnect(); // Para não ficar observando depois que iniciou
        }
      });
    }, { threshold: 0.5 }); // 50% da seção visível

    this.observer.observe(this.contadoresSection.nativeElement);
  }



  ngOnInit(): void {

    if (isPlatformBrowser(this.platformId)) {
      this.checkMobile();
      if (typeof window !== 'undefined') {
        window.addEventListener('resize', this.checkMobile.bind(this));
      }

      // 🔹 Garante que o scroll acontece depois da renderização
      setTimeout(() => {
        window.scrollTo(0, 0);
      });

      // 🔹 Faz o scroll ao navegar entre páginas
      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          setTimeout(() => {
            window.scrollTo(0, 0);
          });
        }
      });
    }
  }

  iniciarContadores() {
    this.contadores.forEach((contador, index) => {
      const incremento = Math.ceil(contador.alvo / 100);
      const interval = setInterval(() => {
        if (contador.valor < contador.alvo) {
          contador.valor += incremento;
          if (contador.valor > contador.alvo) contador.valor = contador.alvo;
        } else {
          clearInterval(interval);
        }
      }, 65);
    });
  }

  mobile: boolean = false
  checkMobile() {
    if (typeof window !== 'undefined') {
      this.mobile = window.innerWidth < 935;
    }
  }

  cards = [
    {
      title: 'Menos burocracia',
      content: 'Modalidades conforme seu perfil, opções sem burocracia e sem custo adicional. Agende sua visita online, análise de crédito em 15 minutos e assinatura digital do contrato.'
    },
    {
      title: 'Aluguel sem fiador',
      content: 'Aluguel descomplicado, sem a necessidade de um fiador, assim você não precisa pedir ajuda na hora de alugar um imóvel.'
    },
    {
      title: 'Equipe proativa',
      content: 'Contamos com mais de 80 colaboradores à sua disposição. Receba assessoria de um agente de locação até o imóvel.'
    },
    {
      title: 'Alta visibilidade',
      content: 'Mais de 50 mil acessos por mês ao site, além de amplo investimento em divulgação.'
    }
  ];


  unidades = [
    { nome: 'Matriz Dores', endereco: 'Av. Nossa Senhora das Dores, 2347', foto: '../../assets/unidades/matriz.jpg' },
    { nome: 'Agencia Centro', endereco: 'Rua Venâncio Aires, 1349 loja 2', foto: '../../assets/unidades/centro.webp' },
    { nome: 'Agencia Camobi', endereco: 'Av. Prefeito Evandro Behr, 7300', foto: '../../assets/unidades/camobi-2.webp' },
    { nome: 'Agencia Hélvio-Basso', endereco: 'Av. Hélvio Basso, 535', foto: '../../assets/unidades/helvio-basso.webp' }
  ];

  pilares = [
    { label: 'Excelência', icon: 'fas fa-star' },
    { label: 'Credibilidade', icon: 'fas fa-check-circle' },
    { label: 'Humildade', icon: 'fas fa-handshake' },
    { label: 'Meritocracia', icon: 'fas fa-trophy' },
    { label: 'Ética', icon: 'fas fa-balance-scale' }
  ];

  contadores = [
    { valor: 0, alvo: 15000, prefixo: '+', sufixo: '', descricao: 'chaves entregues', icone: 'fa-solid fa-key' },
    { valor: 0, alvo: 1300000000, prefixo: '+R$', sufixo: '', descricao: 'em imóveis comercializados', icone: 'fa-solid fa-building-columns' },
    { valor: 0, alvo: 80, prefixo: '+', sufixo: '', descricao: 'colaboradores especializados', icone: 'fa-solid fa-users' },
    { valor: 0, alvo: 4, prefixo: '', sufixo: '', descricao: 'lojas na cidade (sendo 2 próprias)', icone: 'fa-solid fa-store' }
  ];

  acessaContato() {
    this.router.navigate(['/contato']);
  }

  formatarNumero(valor: number): string {
    if (valor >= 1_000_000_000) {
      return (valor / 1_000_000_000).toFixed(1).replace(/\.0$/, '') + ' bilhão' + (valor / 1_000_000_000 >= 2 ? 's' : '');
    }
    if (valor >= 1_000_000) {
      return (valor / 1_000_000).toFixed(1).replace(/\.0$/, '') + ' milhão' + (valor / 1_000_000 >= 2 ? 's' : '');
    }
    if (valor >= 1_000) {
      return (valor / 1_000).toFixed(1).replace(/\.0$/, '') + ' mil';
    }
    return valor.toString();
  }
}
